import { panoramaClient, createGlobalConfig as _createGlobalConfig } from '@wix/panorama-client';
import { batchPlugin, environmentPlugin, sentryPlugin, topLevelPropsExtractorPlugin, pageParamsEnricherPlugin } from '@wix/panorama-client/plugins';
import { CLICKHOUSE_BATCH_REPORT_URL } from '@wix/panorama-common-shared/constants';
import { BATCH_THROTTLE_DURATION_MS, EXTRA_BASE_PARAMS } from './constants';
import { webReporter } from './reporter';

// Since we now support both legacy (v5) and v7 Sentry SDKs this is the cleanest way for now to prevent TS conflicts between the two

export const panoramaClientFactory = options => {
  const {
    baseParams,
    pluginParams,
    pageParams,
    data,
    reporterOptions
  } = options;
  const {
    useBatch = true,
    sentry,
    sentryDsn,
    sentryMain,
    sentryEnvironment,
    sentryTransport
  } = pluginParams ?? {};
  const {
    fetchFn
  } = reporterOptions ?? {};
  const factory = panoramaClient({
    baseParams,
    data
  }).use(pageParamsEnricherPlugin(pageParams)).use(topLevelPropsExtractorPlugin(EXTRA_BASE_PARAMS)).use(environmentPlugin()).use(sentryPlugin({
    sentry,
    sentryDsn,
    sentryMain,
    sentryEnvironment,
    sentryTransport
  })).withReporter(webReporter(CLICKHOUSE_BATCH_REPORT_URL, fetchFn));
  if (useBatch) {
    factory.use(batchPlugin(BATCH_THROTTLE_DURATION_MS));
  }

  // @ts-expect-error
  factory.use = undefined;
  return factory;
};
export const createGlobalConfig = () => _createGlobalConfig();
//# sourceMappingURL=panorama-client-web.js.map